import {
  radioSchema,
  radioUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  expectedSeparationLabels,
  expectedSeparationTypes,
} from '../constants/benefits';

export default {
  uiSchema: {
    expectedSeparation: radioUI({
      title: 'When do you expect to separate or retire from the service?',
      labels: expectedSeparationLabels,
      hideIf: formData => formData.militaryServiceCurrentlyServing !== true,
    }),
  },
  schema: {
    type: 'object',
    properties: {
      expectedSeparation: radioSchema(Object.keys(expectedSeparationTypes)),
    },
  },
};
